import { Avatar } from "@nextui-org/react";
import { capitalize } from "../../../controllers/APIController";
import { DeleteTableItem } from "../../../utils/helper";
import { Colors, numColors } from "../../../utils/constant";

/**
 * DrawerHeader Component
 * Header section of the user drawer showing user avatar, name, and delete option
 * Displays user profile information with a delete button for administrators
 * @param {Object} props - Component props
 * @param {Object} props.User - User object containing user information
 * @param {Function} props.onOpenChange - Function to handle drawer open/close state
 * @returns {JSX.Element} User drawer header with profile information
 */
const DrawerHeader = ({ User, onOpenChange }) => {
  // Extract and format user name from first name or email
  const extractedName = capitalize(User?.FirstName || User?.email?.split("@")[0]);

  // Calculate avatar color based on user ID
  const colorIndex = User?.id % numColors;

  /**
   * Handle user deletion
   * Currently just closes the drawer (delete functionality commented out)
   * @param {number} id - User ID to delete
   */
  const handleDelete = async (id) => {
    // TODO: Implement user deletion functionality
    // const result = await DeleteOnedata("users", User?.id);
    onOpenChange();
  };

  return (
    <div className="flex flex-col items-center w-full">
      {/* Delete User Button (Admin Only) */}
      <div className="flex items-center justify-end w-full mr-8 mt-2">
        <DeleteTableItem
          userRole={"Admin"}
          toolTiptext={"Remove User"}
          DropDownText={"Want to delete User"}
          deleteHandler={handleDelete}
        />
      </div>
      
      {/* User Profile Information */}
      <div className="flex flex-col items-center">
        {/* User Avatar */}
        <Avatar
          src={User?.ProfilePictureUrl || ""}
          color={Colors[colorIndex]}
          name={User?.email?.slice(0, 1).toUpperCase() || ""}
          className="w-28 h-28 my-4 mt-12"
          classNames={{ name: "w-8 h-8 text-3xl" }}
        />
        
        {/* User Name and Email */}
        <div className="flex flex-col items-center">
          <p className="text-lg font-medium">
            {User?.FirstName || capitalize(extractedName)}
          </p>
          <p className="font-normal text-grey-600 text-medium">
            {User?.email || "vipul.jain@nanoheal.com"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DrawerHeader;
